import React from "react";
import { Link } from "react-router-dom";

const LOGO_LIGHT = `${process.env.PUBLIC_URL}/images/logos/Max_Logo_01.png`;

const MaxAuthMobileBar = () => {
  return (
    <div className="max-auth-mobile-brand">
      <Link to="/" className="max-auth-mobile-brand__logo-link">
        <img src={LOGO_LIGHT} alt="MaX Consulting" className="max-auth-mobile-brand__logo" width={140} height={32} />
      </Link>
      <Link to="/" className="max-auth-mobile-brand__site">
        Website
      </Link>
    </div>
  );
};

export default MaxAuthMobileBar;
